module.exports = __webpack_public_path__ + "img/class1.be08d6c6.png";